import React from 'react'
import { Props as TextItemProps } from 'component-library/typography/TextItem/TextItem'

import { StyledSubhead } from 'component-library/typography/Subhead/Subhead.styled'

export type SubHeadingElements = 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

export type Props = TextItemProps & { tag: SubHeadingElements }

export const Subhead: React.FC<Props> = props => {
    return <StyledSubhead {...props} />
}
Subhead.displayName = 'Subhead'
